import { NAMESPACE } from 'locale'
import { shiftPasswordsConstants } from 'locale/shiftPasswords'
import PropTypes from 'prop-types'
import React, { type FunctionComponent, Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import Field from '../../fields'

interface ShiftPasswordFormProps {
  fields: any
  formId: string
  onCancelEditPassword?: () => void
  type?: 'create' | 'edit'
}

const ShiftPasswordForm: FunctionComponent<ShiftPasswordFormProps> = ({
  fields,
  formId,
  onCancelEditPassword,
  type = 'create'
}) => {
  const { t } = useTranslation(NAMESPACE.SHIFT_PASSWORDS)

  if (!fields) return null

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="title-field"
            formId={formId}
            keys="title"
            label={t(shiftPasswordsConstants.TITLE)}
            note={t(shiftPasswordsConstants.TITLE_DESC)}
            required
            type="text"
            values={fields}
          />
        </Suspense>
      </div>
      <div style={{ marginBottom: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="duration-field"
            formId={formId}
            keys={['startTime', 'endTime']}
            label={t(shiftPasswordsConstants.START_END_TIME)}
            note={t(shiftPasswordsConstants.START_END_DESC)}
            placeholders={[
              t(shiftPasswordsConstants.START_TIME),
              t(shiftPasswordsConstants.END_TIME)
            ]}
            type="duration"
            values={fields}
            required
          />
        </Suspense>
      </div>
      <div style={{ marginBottom: 20 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            formId={formId}
            keys="length"
            label={t(shiftPasswordsConstants.ACCESS_DURATION_HOURS)}
            note={t(shiftPasswordsConstants.ACCESS_DURATION_DESC)}
            options={{
              numeral: true,
              numeralThousandsGroupStyle: 'none'
            }}
            required
            type="number"
            values={fields}
            positiveValuesOnly
            acceptZero={false}
            formFieldStyle={{
              width: '100%'
            }}
            style={{ maxWidth: 'unset' }}
          />
        </Suspense>
      </div>
      {type === 'edit' ? (
        <Field
          className="change-password-field"
          formId={formId}
          keys={['password', 'password_confirm']}
          label={t(shiftPasswordsConstants.SHIFT_PASSWORD)}
          onCancel={onCancelEditPassword}
          type="changePassword"
          values={fields}
        />
      ) : (
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="new-password-field"
            formId={formId}
            inputType="password"
            keys={['password', 'password_confirm']}
            label={t(shiftPasswordsConstants.PASSWORD)}
            placeholders={[
              t(shiftPasswordsConstants.PASSWORD),
              t(shiftPasswordsConstants.CONFIRM_PASSWORD)
            ]}
            required
            type="multiText"
            values={fields}
          />
        </Suspense>
      )}
    </div>
  )
}

export default ShiftPasswordForm
